export default __webpack_public_path__ + "static/media/update.97cca973.svg";